import { DatePicker, Input, Pagination, Select, Table } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { getClientPL } from '../../redux/slice/clientPL/clientPLSlice';
import Loader from "components/loader";
import Appconfig from '../../config/config'
import { useNavigate, useParams } from "react-router-dom";

const ClientPL = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const rowSelection = []
    const { user_id, user_type } = useParams();
    const { data, loading } = useSelector((state) => state.clientPL);
    const { userdata, isAuthenticated } = useSelector((state) => state.authSlice);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const [filteredData, setFilteredData] = useState();

    const [eventType, setEventType] = useState("4");
    const [status, setStatus] = useState("Settled");
    const [fromDate, setFromDate] = useState(dayjs().subtract(1, 'day'));
    const [toDate, setToDate] = useState(dayjs());
    const paginatedData = filteredData?.slice(startIndex, endIndex);
    let locale = {
        emptyText: 'No data!',
    };
    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1);
    };

    const columns = [
        {
            title: "Username",
            dataIndex: "user_name",
            render: (_, record) => (
                <span className="font-extrabold text-[#4083a9] cursor-pointer text-[0.813rem] "
                    onClick={() => navigate(`/clientPL/${record.user_id}/${record?.user_type}`)}
                >
                    {`${record.user_name}(${record.name})`}
                </span>
            ),
        },

        ...(userdata?.user_type != 'User'
            ? Appconfig.userTypes.slice(Appconfig.userTypes.findIndex(userType => userType?.title == userdata?.user_type && userType?.title !== 'User') + 1)?.filter(userType => userType?.title !== 'User')?.map(userType => ({
                title: userType.title,
                dataIndex: userType.alias,
                render: (_, record) => (
                    <span className={`font-extrabold ${record.data.find(data => data?.user_type == userType?.title)?.total_masters_pl >= 0 ? 'text-[#508d0e]' : 'text-[#e22020]'} text-[0.813rem]`}
                    >
                        {record.data.find(data => data?.user_type == userType?.title)?.total_masters_pl}
                    </span>
                ),
            }))
            : []),
        {
            title: "Total",
            dataIndex: "event_name",
            render: (_, record) => (
                <span className={`font-extrabold ${record?.data?.length > 0 && record?.data[0]?.total_user_pl >= 0 ? 'text-[#508d0e]' : 'text-[#e22020]'} text-[0.813rem] `}>
                    {record?.data?.length > 0 && (record?.data[0]?.total_user_pl ? Number(record?.data[0]?.total_user_pl).toFixed(2) : '-')}
                </span>
            ),
        },
        {
            title: "Amount",
            dataIndex: "name",
            // width: "25%",
            render: (_, record) => (
                <span className={`font-extrabold ${record?.data?.length > 0 && record?.data[0]?.total_masters_pl >= 0 ? 'text-[#508d0e]' : 'text-[#e22020]'} text-[0.813rem] `}>
                    {record?.data?.length > 0 && (record?.data?.find(data => data?.user_type == user_type ? user_type : userdata?.user_type)?.total_masters_pl ? Number(record?.data?.find(data => data?.user_type == user_type ? user_type : userdata?.user_type)?.total_masters_pl).toFixed(2) : '-')}
                </span>
            ),
        },
        {
            title: "M-comm",
            dataIndex: "betting_type",
            // width: "25%",
            render: (_, record) => (
                <span className="font-extrabold text-[#508d0e] text-[0.813rem] ">
                    0.00
                </span>
            ),
        },
        {
            title: "S-comm",
            dataIndex: "price_val",
            // width: "25%",
            render: (_, record) => (
                <span className="font-extrabold text-[#508d0e] text-[0.813rem] ">
                    0.00
                </span>
            ),
        },
        {
            title: "Net-Amount",
            dataIndex: "name",
            // width: "25%",
            render: (_, record) => (
                <span className={`font-extrabold ${record?.data?.length > 0 && record?.data[0]?.total_masters_pl >= 0 ? 'text-[#508d0e]' : 'text-[#e22020]'} text-[0.813rem] `}>
                    {record?.data?.length > 0 && (record?.data?.find(data => data?.user_type == user_type ? user_type : userdata?.user_type)?.total_masters_pl ? Number(record?.data?.find(data => data?.user_type == user_type ? user_type : userdata?.user_type)?.total_masters_pl).toFixed(2) : '-')}
                </span>
            ),
        },
        {
            title: 'User PL',
            dataIndex: 'P_L	',
            // width: '12%',
            render: (_, record) => (
                <span className={`font-extrabold ${record?.data?.length > 0 && record?.data[0]?.total_user_pl >= 0 ? 'text-[#508d0e]' : 'text-[#e22020]'} text-[0.813rem] `}>
                    {record?.data?.length > 0 && (record?.data[0]?.total_user_pl ? Number(record?.data[0]?.total_user_pl).toFixed(2) : '-')}
                </span>
            ),
        },
    ];
    const handleGoClick = () => {
        const params = {
            user_id: user_id,
            from_date: fromDate.format("YYYY-MM-DD"),
            to_date: toDate.format("YYYY-MM-DD"),
        };
        if (isAuthenticated) {
            dispatch(getClientPL(params));
        }
    };

    useEffect(() => {
        const params = {
            user_id: user_id,
            from_date: fromDate.format("YYYY-MM-DD"),
            to_date: toDate.format("YYYY-MM-DD"),
        };
        if (isAuthenticated) {
            dispatch(getClientPL(params));
        }
    }, [user_id, isAuthenticated])

    const handleResetClick = () => {
        setEventType("4");
        setStatus("Settled");
        setFromDate(dayjs().subtract(1, 'day'));
        setToDate(dayjs());
    };

    useEffect(() => {
        if (data) {
            setFilteredData(data.reports)
        }
    }, [data])


    const handleSearch = (value, dataIndex) => {

        if (!value) {
            setFilteredData(data?.reports)
            return;
        }

        const filtered = data?.reports?.filter(item => {
            return Array.isArray(dataIndex)
                ? dataIndex.some(key => item[key]?.toString().toLowerCase().includes(value.toLowerCase()))
                : item[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase());
        });

        // const filtered = data.length ? data.filter(item => item[dataIndex].toString().toLowerCase().includes(value.toLowerCase())) : [];
        setFilteredData(filtered);
        setCurrent(1); // Reset to the first page after a search
    };
    return (
        <>
            {
                loading && <Loader />
            }
            <div className='relative min-w-full'>
                <div className='grid grid-cols-12 lg:px-[6px] mt-[.5rem] lg:mt-0'>
                    <div className='col-span-12'>
                        <div className='relative w-full'>
                            <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>Client PL</p>
                        </div>
                        <div className="bg-[#fff] text-[#000] mb-[10px] min-h-[500px] w-full">
                            <div className="grid grid-cols-12">
                                <div className="col-span-12 lg:col-span-2 !mt-[.5rem] relative !px-[6px] !py-[0]">
                                    <div className="text-[15px] relative mb-4">
                                        <DatePicker
                                            inputReadOnly
                                            className="!w-full"
                                            onChange={(date) => setFromDate(date)}
                                            value={fromDate}
                                            allowClear={false}

                                            format="DD/MM/YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-span-12 lg:col-span-2 !mt-[.5rem] relative !px-[6px] !py-[0]">
                                    <div className="text-[15px] relative mb-4">
                                        <DatePicker
                                            inputReadOnly
                                            className="!w-full"
                                            onChange={(date) => setToDate(date)}
                                            value={toDate}
                                            allowClear={false}

                                            format="DD/MM/YYYY"
                                        />
                                    </div>
                                </div>
                                <div className="col-span-12 lg:col-span-2 !mb-4 !mt-[.5rem] relative w-full !px-[6px] !py-[0]">
                                    <div className="inline-flex relative align-middle" role="group" aria-label="Basic example" id="divpagecount">
                                        <button type="button" className="rounded-br-none rounded-tr-none flex-auto relative cursor-pointer bg-[linear-gradient(-180deg,_#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#146578] text-[#fff] rounded-[3px] text-[14px] outline-[none] px-[20px] py-[5px] text-center inline-block font-normal leading-normal [transition:color_.15sease-in-out,_background-color_.15sease-in-out,_border-color_.15sease-in-out,_box-shadow_.15sease-in-out]" onClick={handleGoClick}>Go</button>
                                        <button type="button" className="rounded-bl-none rounded-tl-none flex-auto relative cursor-pointer bg-[linear-gradient(-180deg,_#5ecbdd,_#146578)] border-[1px] border-[solid] border-[#146578] text-[#fff] rounded-[3px] text-[14px] outline-[none] px-[20px] py-[5px] text-center inline-block font-normal leading-normal [transition:color_.15sease-in-out,_background-color_.15sease-in-out,_border-color_.15sease-in-out,_box-shadow_.15sease-in-out] ml-[.25rem]" onClick={handleResetClick}>Reset</button>
                                    </div>
                                </div>
                            </div>

                            <div className='col-span-12'>
                                <Table
                                    title={() => (
                                        <div className='grid grid-cols-12 my-[.5rem]'>
                                            <div className='col-span-12 lg:col-span-6 flex items-center mt-[.25rem] justify-start '>
                                                <div className=' flex float-left'>
                                                    <div className="text-[15px] relative flex gap-2 w-[200px]">
                                                        Search:
                                                        <Input
                                                            onChange={e => handleSearch(e.target.value, ['user_name', 'name', 'total_masters_pl', 'total_user_pl'])}
                                                            className="!text-[12px] h-[30px] pl-[2px] pr-[5px] py-[5px] bg-clip-padding !bg-[#fff] border-[1px] border-[solid] !border-[#ced4da] rounded-[.25rem] !text-[#495057] block font-normal leading-normal [transition:border-color_.15sease-in-out,_box-shadow_.15sease-in-out] w-full"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-span-12 lg:col-span-6 flex items-center justify-end  '>
                                                <div className='  p-[.5rem] lg:p-[0px]'>
                                                    <span class="text-[#000] float-right text-[14px] mr-[5px] mt-[4px] !ml-[.5rem] !inline2">entries</span>
                                                    <div className="text-[15px] relative float-right">
                                                        <Select defaultValue={10} onChange={handlePageSizeChange} className='pagesize-select mx-[5px] '>
                                                            <Select.Option value={10}>10</Select.Option>
                                                            <Select.Option value={25}>25</Select.Option>
                                                            <Select.Option value={50}>50</Select.Option>
                                                            <Select.Option value={100}>100</Select.Option>
                                                        </Select>
                                                    </div>
                                                    <span class="text-[#000] float-right text-[14px] mr-[5px] mt-[4px] !inline">Show</span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    locale={locale}
                                    columns={columns}
                                    className='px-[.5rem] '
                                    bordered
                                    dataSource={paginatedData}
                                    pagination={false}
                                />
                                <div className='grid grid-cols-12 items-center py-[1rem] px-[.5rem]'>
                                    <div className='col-span-12 lg:col-span-6  '>
                                        Showing {startIndex + 1} - {endIndex} of {filteredData && filteredData.length} entries
                                    </div>
                                    <div className='col-span-12 lg:col-span-6 flex items-center justify-end  pt-[1rem] lg:pt-[0px] lg:mt-[0rem]'>
                                        <Pagination
                                            current={current}
                                            pageSize={pageSize}
                                            total={filteredData && filteredData.length}
                                            onChange={(page) => setCurrent(page)}
                                            itemRender={(page, type, originalElement) => {
                                                if (type === 'prev') {
                                                    return <button type='button' className='!cursor-pointer'>Prev</button>;
                                                }
                                                if (type === 'page') {
                                                    return null;
                                                }
                                                if (type === 'next') {
                                                    return <button type='button' className='!cursor-pointer'>Next</button>;
                                                }
                                                return originalElement;
                                            }}
                                            showSizeChanger={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div >

                </div >
            </div >
        </>
    )
}
export default ClientPL